import { ReactNode, memo, useCallback, useMemo, useState } from 'react';

import { Typography } from '@material-ui/core';

import { isTouchDevice } from '../../utils';
import { Tooltip } from '../tooltip/Tooltip';
import { TouchFriendlyTooltipProps } from './TouchFriendlyTooltip.types';

export const TouchFriendlyTooltip = memo(
  ({ title, children, tooltipClasses, classes, disabled, ...props }: TouchFriendlyTooltipProps) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const touchDevice = useMemo(() => isTouchDevice(), []);

    const handleOpenTooltip = useCallback(() => {
      if (disabled || !touchDevice) {
        return;
      }

      setIsTooltipOpen(true);
    }, [disabled, touchDevice]);

    return (
      <Tooltip
        open={touchDevice ? isTooltipOpen : undefined}
        title={
          typeof title === 'string' ? (
            <Typography variant="body1">{title}</Typography>
          ) : (
            (title as NonNullable<ReactNode>)
          )
        }
        isArrow
        interactive
        placement="top"
        disabled={disabled}
        classes={tooltipClasses}
        onClose={() => setIsTooltipOpen(false)}
        {...props}
      >
        <div className={classes?.content} onClick={handleOpenTooltip}>
          {children}
        </div>
      </Tooltip>
    );
  },
);
